module.exports = __webpack_public_path__ + "static/photo-6ef3c2d9b9647a9855c5665d6d8dc712.jpg";